import React, { Component } from 'react';

export const DDGroupContext = React.createContext({
    getDDProps: () => {},
});

class SeDropdownGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dropdownStates: {},
        };
        this.dropdowns = [];
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    UNSAFE_componentWillMount() {
        ['touchstart', 'mousedown'].forEach(evName => document.addEventListener(evName, this.handleClickOutside));
    }

    componentWillUnmount() {
        ['touchstart', 'mousedown'].forEach(evName => document.removeEventListener(evName, this.handleClickOutside));
    }

    handleClickOutside(ev) {
        const ddClassSelector = '.se-dropdown';
        if (!ev.target.closest(ddClassSelector) && !ev.target.matches(ddClassSelector)) {
            this.closeDropdowns();
        }
    }

    closeDropdowns = () => {
        const newDropdownStates = {};
        this.dropdowns.forEach(ddId => {
            newDropdownStates[ddId] = false;
        });

        this.setState({ dropdownStates: newDropdownStates });
    };

    handleDDOpen = (activeDDId, isDDOpen) => {
        const newDropdownStates = {};
        this.dropdowns.forEach(ddId => {
            newDropdownStates[ddId] = ddId === activeDDId ? !isDDOpen : false;
        });

        this.setState({ dropdownStates: newDropdownStates });
    };

    getDDProps = ddId => {
        if (!this.dropdowns.includes(ddId)) {
            this.dropdowns.push(ddId);
        }

        return {
            ddId,
            open: !!this.state.dropdownStates[ddId],
            onOpen: this.handleDDOpen,
        };
    };

    render() {
        const context = {
            getDDProps: this.getDDProps,
        };
        return <DDGroupContext.Provider value={context}>{this.props.children}</DDGroupContext.Provider>;
    }
}

export default SeDropdownGroup;
